import { registerOverlay } from 'klinecharts'
import { NO_DEFAULT_FIGURES, type OverlayTemplateParam } from './registrationUtils'

const BEAT_COLOR = 'rgba(34, 197, 94, 0.9)' // green
const MISS_COLOR = 'rgba(239, 68, 68, 0.9)' // red
const NEUTRAL_COLOR = 'rgba(160, 165, 180, 0.7)' // muted

/**
 * Custom overlay that marks an earnings date on the chart.
 * Renders a small colored dot at the bar's close price.
 *
 * Pass `extendData` as `{ type: 'beat' | 'miss' | 'neutral' }`.
 * Pass the close price as the point's `value` to position the dot correctly.
 */
export function registerEarningsMarkerOverlay(): void {
  registerOverlay({
    name: 'earningsMarker',
    totalStep: 2,
    ...NO_DEFAULT_FIGURES,
    createPointFigures: ({ coordinates, overlay }) => {
      if (coordinates.length === 0) return []

      const x = coordinates[0].x
      const y = coordinates[0].y
      const ext = (overlay.extendData as { type?: string }) ?? {}
      const type = ext.type ?? 'neutral'

      const color = type === 'beat' ? BEAT_COLOR : type === 'miss' ? MISS_COLOR : NEUTRAL_COLOR

      return [
        {
          type: 'circle',
          attrs: {
            x,
            y,
            r: 5,
          },
          styles: {
            style: 'fill',
            color,
          },
          ignoreEvent: true,
        },
        // Thin white border for contrast
        {
          type: 'circle',
          attrs: {
            x,
            y,
            r: 5,
          },
          styles: {
            style: 'stroke',
            color: 'rgba(255, 255, 255, 0.4)',
            size: 1,
          },
          ignoreEvent: true,
        },
      ]
    },
  } as OverlayTemplateParam)
}
